import { useCallback, useEffect, useState } from "react";
import {
  fetchPolicyCheckCompanies,
  type PolicyCheckCompany,
} from "../api/policyCheck";
import { getApiErrorMessage } from "../utils/getApiErrorMessage";

interface UsePolicyCheckCompaniesOptions {
  page: number;
  pageSize: number;
  enabled?: boolean;
}

export const usePolicyCheckCompanies = ({
  page,
  pageSize,
  enabled = true,
}: UsePolicyCheckCompaniesOptions) => {
  const [data, setData] = useState<PolicyCheckCompany[]>([]);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(enabled);
  const [error, setError] = useState<string | null>(null);
  const [reloadToken, setReloadToken] = useState(0);

  const refetch = useCallback(() => {
    setReloadToken((token) => token + 1);
  }, []);

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    fetchPolicyCheckCompanies({ page, pageSize })
      .then((response) => {
        if (!cancelled) {
          setData(response.items);
          setTotalPages(response.totalPages);
        }
      })
      .catch((err: unknown) => {
        if (!cancelled) {
          setError(getApiErrorMessage(err, "Не удалось загрузить проверки политики"));
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [page, pageSize, enabled, reloadToken]);

  return { data, totalPages, loading, error, refetch };
};
